// Calendly URL for every premium-gated CTA. Single source of truth
// so the destination flips in one place if the booking link ever
// changes. Replace seidr.site/pricing#book everywhere this is imported.
//
// 2026-06-07 (Implementation Brief): every Premium trigger now opens
// Calendly with the user's Auth0 email pre-filled. The Calendly page
// is expected to have "Company" and "Why would you like to use it?"
// configured as custom questions — those are set up Calendly-side,
// not in this repo.
export const CALENDLY_URL = 'https://calendly.com/benjamin-respire/seidr';

/**
 * Build a Calendly URL with email pre-filled. Calendly accepts
 * `email` and `name` as `?prefill[...]` keys natively; custom
 * questions go in the booking flow.
 *
 * @param {string|null|undefined} email — Auth0 user email, if known.
 * @param {string|null|undefined} name  — display name, optional.
 * @returns {string} Calendly URL ready for window.open / href.
 */
export function calendlyWithPrefill(email, name) {
  const params = new URLSearchParams();
  if (email) params.set('email', email);
  if (name) params.set('name', name);
  const qs = params.toString();
  return qs ? `${CALENDLY_URL}?${qs}` : CALENDLY_URL;
}

/**
 * Open Calendly in a new tab. Convenience wrapper so component
 * code doesn't repeat window.open + noopener boilerplate.
 *
 * @param {{email?: string, name?: string}} user — usually pulled
 *   from useAuth0().user.
 */
export function openCalendly(user) {
  const url = calendlyWithPrefill(user?.email, user?.name);
  window.open(url, '_blank', 'noopener,noreferrer');
}
